import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../../assets/brand/pintarpilihkuliah-wordmark.png";
import { trackEvent } from "../../utils/analyticsUtils";
import "./Navbar.css";

const navigation = [
  { label: "Program", to: "/#pilih-program" },
  { label: "Mentoring", to: "/#mentoring" },
  { label: "Cerita Alumni", to: "/#kisah-siswa" },
  { label: "FAQ", to: "/#faq" },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="site-nav">
      <div className="site-nav__inner">
        <Link
          to="/"
          className="site-nav__brand"
          onClick={closeMenu}
          aria-label="#PintarPilihKuliah, beranda"
        >
          <img src={logo} alt="#PintarPilihKuliah" width="1081" height="265" />
        </Link>

        <nav className="site-nav__desktop" aria-label="Navigasi utama">
          {navigation.map((item) => (
            <Link key={item.label} to={item.to}>
              {item.label}
            </Link>
          ))}
        </nav>

        <Link
          to="/#pilih-program"
          className="site-nav__cta"
          onClick={() =>
            trackEvent("Conversion", "nav_cta_click", "pilih-program")
          }
        >
          Pilih Program
        </Link>

        <button
          type="button"
          className="site-nav__toggle"
          aria-label={isMenuOpen ? "Tutup menu" : "Buka menu"}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-navigation"
          onClick={() => setIsMenuOpen((current) => !current)}
        >
          {isMenuOpen ? (
            <X size={24} aria-hidden="true" />
          ) : (
            <Menu size={24} aria-hidden="true" />
          )}
        </button>
      </div>

      <div
        id="mobile-navigation"
        className={isMenuOpen ? "site-nav__mobile is-open" : "site-nav__mobile"}
      >
        <nav aria-label="Navigasi seluler">
          {navigation.map((item) => (
            <Link key={item.label} to={item.to} onClick={closeMenu}>
              {item.label}
            </Link>
          ))}
          <Link
            to="/#pilih-program"
            className="site-nav__mobile-cta"
            onClick={() => {
              trackEvent("Conversion", "nav_cta_click", "pilih-program-mobile");
              closeMenu();
            }}
          >
            Pilih Program
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
